module.exports = __webpack_public_path__ + "img/horizontal_4_7_8004.bcbd148d.png";